import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { H1, StringMain } from '@/components/Typography/Typography';

import { Loader } from '../Loader/Loader';
import { InfinityTimer } from '../Timer/InfinityTimer';

import css from './style.module.scss';

const PendingStatus: React.FC = () => {
  const { t } = useTranslation();
  const [value, setValue] = useState<number>(60);

  useEffect(() => {
    const timer = setInterval(() => setValue((prev) => prev - 1), 1000);

    return (): void => clearInterval(timer);
  }, []);

  return (
    <>
      <div className={css.title}>
        <H1>{t('Purchase in progress')}</H1>
      </div>
      <div className="flex flex-col gap-[65px] mt-[100px] items-center">
        <Loader size={64} />
        {value >= 0 && (
          <InfinityTimer classNames="!text-[40px]" value={value} />
        )}
        <StringMain weight="extrabold">
          {t('You can close this window')}
        </StringMain>
      </div>
    </>
  );
};

export default PendingStatus;
